import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable'
import { environment } from 'environments/environment';

@Injectable()
export class TransactionAttachmentService {

    constructor(private http: HttpClient) { }

    add = (data): Observable<any> => {
        return this.http.post<any>(`${environment.order}/TransactionAttachment`, data);
    }
}